import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { QuestionGroupService } from '../../services/question.group.service';
import { QuestionGroup } from '../../models/question.group.model';
import { AccessRight } from '../../enums/access.right.enum';

@Component({
    selector: 'questiongroup-list',
    templateUrl: './questiongroup-list.component.html',
    styleUrls: ['./questiongroup-list.component.css'],
    providers: [QuestionGroupService, ErrorHandler]
})
export class QuestionGroupListComponent implements OnInit {
    questionGroups: Array<QuestionGroup>;
    isDataAvailable = false;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private questionGroupService: QuestionGroupService)
    {
        this.questionGroups = new Array<QuestionGroup>();
    }

    ngOnInit() {
        this.getAll();
    }

    getAll(): void {
        this.questionGroupService.getQuestionGroups()
            .then(questionGroups => {
                this.questionGroups = questionGroups;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    edit(questionGroupId: string): void {
        this.router.navigate(['questiongroup/detail', questionGroupId]);
    }

    add(): void {
        this.router.navigate(['questiongroup/detail', 0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/questiongroup-list/questiongroup-list.component.ts